export default "/static/vision_m1_tiny.png";